import React from "react";
import PageTemplate from "../components/PageTemplate";

const Philanthropy = () => {
  return (
    <PageTemplate>
      <div className="min-h-screen bg-gradient-to-br from-cream-100 via-peach-50 to-cream-100">
        {/* Hero Section */}
        <div className="relative py-8 sm:py-12 lg:py-16 overflow-hidden bg-gradient-to-br from-pink-100 via-coral-100 to-cream-100">
          <div className="max-w-6xl mx-auto text-center relative z-10 px-4 sm:px-6 lg:px-8">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-text font-bold text-coral mb-4 sm:mb-6 animate-fade-in drop-shadow-lg">
              Philanthropy
            </h1>
            
            {/* Mission Statement as Subtitle */}
            <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-teal-600 font-text leading-relaxed max-w-4xl mx-auto mb-4 sm:mb-6 animate-fade-in">
              Our Mission is to promote cultural awareness and diversity of South Asian Culture through our annual dance competition, NJ Naach, hosted for charity.
            </p>
            
            {/* Enhanced decorative wave line */}
            <div className="w-16 sm:w-20 lg:w-24 h-1 bg-coral rounded-full mx-auto shadow-lg"></div>
          </div>
        </div>

        {/* Project Stree Section */}
        <div className="py-12 sm:py-16 lg:py-20 px-4 sm:px-6 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
              {/* Content Side */}
              <div className="text-center lg:text-left">
                <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-text font-bold text-coral mb-6 sm:mb-8">
                  Project Stree
                </h2>
                <p className="text-lg sm:text-xl lg:text-2xl text-teal-600 font-text leading-relaxed mb-8 sm:mb-12">
                  Project Stree's mission is to empower Indian women by increasing awareness about hygiene habits and challenging the stigma around women's health.
                </p>
                
                {/* Social Media Links */}
                <div className="flex flex-col sm:flex-row justify-center lg:justify-start space-y-4 sm:space-y-0 sm:space-x-4 lg:space-x-6">
                  <a 
                    href="https://projectstree.org" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center px-8 sm:px-10 py-4 sm:py-5 bg-teal text-white rounded-full hover:bg-teal-400 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105 font-button font-semibold text-base sm:text-lg"
                  >
                    Website
                  </a>
                  <a 
                    href="https://www.instagram.com/projstree" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center px-8 sm:px-10 py-4 sm:py-5 bg-pink text-white rounded-full hover:bg-pink-400 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105 font-button font-semibold text-base sm:text-lg"
                  >
                    Instagram
                  </a>
                  <a 
                    href="https://www.facebook.com/projectstree/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center px-8 sm:px-10 py-4 sm:py-5 bg-lavender text-white rounded-full hover:bg-lavender-400 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105 font-button font-semibold text-base sm:text-lg"
                  >
                    Facebook
                  </a>
                </div>
              </div>
              
              {/* Image Side */}
              <div className="flex justify-center lg:justify-end">
                <div className="relative">
                  {/* Decorative elements around image */}
                  <div className="absolute -top-4 -left-4 w-8 h-8 bg-gradient-to-r from-yellow-300 to-orange-300 rounded-full opacity-80 animate-pulse"></div>
                  <div className="absolute -top-2 -right-2 w-6 h-6 bg-gradient-to-r from-seafoam-300 to-coral-300 rounded-full opacity-80 animate-pulse" style={{ animationDelay: '0.5s' }}></div>
                  <div className="absolute -bottom-3 -left-2 w-5 h-5 bg-gradient-to-r from-beach-300 to-sand-300 rounded-full opacity-80 animate-pulse" style={{ animationDelay: '1s' }}></div>
                  
                  <img 
                    src="/images/ProjectStree.jpg" 
                    alt="Project Stree" 
                    className="w-80 h-80 sm:w-96 sm:h-96 lg:w-[28rem] lg:h-[28rem] object-cover rounded-2xl shadow-2xl border-4 border-white transform rotate-2 hover:rotate-0 transition-all duration-500"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageTemplate>
  );
};

export default Philanthropy;
